import * as t from 'io-ts'

import { EuroCents } from '@espoon-voltti/ts-libs/lib/euro'

export * from './attachment'
export * from './event'
export * from './grant-period'
export * from './form-data'

export const DraftState = t.literal('DRAFT')
export type DraftState = t.TypeOf<typeof DraftState>

export const SigningState = t.literal('SIGNING')
export type SigningState = t.TypeOf<typeof SigningState>

export const SentState = t.literal('SENT')
export type SentState = t.TypeOf<typeof SentState>

export const ReviewState = t.literal('REVIEW')
export type ReviewState = t.TypeOf<typeof ReviewState>

export const PaymentWaitState = t.literal('PAYMENT_WAIT')
export type PaymentWaitState = t.TypeOf<typeof PaymentWaitState>

export const PreReportState = t.literal('PRE_REPORT')
export type PreReportState = t.TypeOf<typeof PreReportState>

export const RejectedState = t.literal('REJECTED')
export type RejectedState = t.TypeOf<typeof RejectedState>

export const PostReportState = t.literal('POST_REPORT')
export type PostReportState = t.TypeOf<typeof PostReportState>

export const RecoveryState = t.literal('RECOVERY')
export type RecoveryState = t.TypeOf<typeof RecoveryState>

export const RecoveredState = t.literal('RECOVERED')
export type RecoveredState = t.TypeOf<typeof RecoveredState>

export const PaidState = t.literal('PAID')
export type PaidState = t.TypeOf<typeof PaidState>

export interface Transaction {
  description: string
  amount: EuroCents
}

export interface AgeDistribution {
  ages7to20: number
  ages21to28: number
  ages29andOver: number
}
